import React from 'react';

interface Props {
  value: number;
  onValueChange: (v: number) => void;
  step?: number;
  minimum?: number;
  maximum?: number;
  label?: string;
  disabled?: boolean;
}

const StepperInputWeb: React.FC<Props> = ({ value, onValueChange, step = 1, minimum = 0, maximum = Infinity, label, disabled = false }) => {
  const handleInc = () => {
    if (disabled) return;
    const next = Math.min(value + step, maximum);
    onValueChange(parseFloat(next.toFixed(2)));
  };
  const handleDec = () => {
    if (disabled) return;
    const next = Math.max(value - step, minimum);
    onValueChange(parseFloat(next.toFixed(2)));
  };

  const display = Number.isInteger(step) ? value.toFixed(0) : value.toFixed(1);

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 8, background: '#f7f7f7', borderRadius: 8, border: '1px solid #e5e7eb', padding: '6px' }}>
      <button onClick={handleDec} disabled={disabled || value <= minimum} style={{ width: 36, height: 36, borderRadius: 6, border: 'none', background: '#fff', cursor: disabled ? 'not-allowed' : 'pointer' }}>-</button>
      <div style={{ display: 'flex', alignItems: 'baseline', gap: 6, whiteSpace: 'nowrap' }}>
        <div style={{ color: '#fb6d3a', fontWeight: 600 }}>{display}</div>
        {label && <div style={{ fontSize: 12, color: '#666', marginLeft: 4 }}>{label}</div>}
      </div>
      <button onClick={handleInc} disabled={disabled || value >= maximum} style={{ width: 36, height: 36, borderRadius: 6, border: 'none', background: '#fff', cursor: disabled ? 'not-allowed' : 'pointer' }}>+</button>
    </div>
  );
};

export default StepperInputWeb;
